import { Box, Chip, Divider, MenuItem, Select, Stack, Typography } from '@mui/material';
import { Product } from '@protos/product';
import { NumberInput } from '@shared/components/NumberInput';
import { SearchGroupedProducts } from '@shared/components/SearchGroupedProducts';

export const FreemiumNumberEditor = ({
  value,
  max,
  min,
  onChange,
  title,
  label,
}: {
  value: number;
  max: number;
  min: number;
  onChange: (value: number) => void;
  title: string;
  label: string;
}) => (
  <Box display="flex" flexDirection="column" gap={2} width="50%">
    <Typography variant="h6">{title}</Typography>
    <NumberInput value={value} onChange={(e, value) => onChange(value as number)} min={min} max={max} allowClearable label={label} />
  </Box>
);

export const ProductSelectionEditor = ({
  allProductGroups,
  selectedProducts,
  onCheckboxChange,
  onDelete,
  isSelectionDisabled,
  symbols,
  title,
}: {
  allProductGroups: { [key: string]: Product[] };
  selectedProducts: Product[];
  onCheckboxChange: (product: Product) => void;
  isSelectionDisabled: (product: Product) => boolean;
  maxProductsLimit: number;
  onDelete: (id: number) => void;
  symbols: string[];
  title: string;
}) => (
  <>
    <Box display="flex" flexDirection="column" marginRight={2} gap={1} width="100%">
      <Typography variant="h6">{title}</Typography>
      <Stack direction="column" alignItems="flex-start">
        <Box display="flex" flexDirection="row" alignItems="center" flexWrap="wrap" gap={1}>
          {symbols?.map((productSymbol, id) => (
            <Chip key={`${productSymbol}`} label={productSymbol} onDelete={() => onDelete(id)} size="small" sx={{ fontSize: 10 }} />
          ))}
        </Box>

        <Stack marginTop={2} width="100%">
          <SearchGroupedProducts
            allProductGroups={allProductGroups}
            allSelectedProducts={selectedProducts}
            selectedUserProducts={selectedProducts}
            onProductClick={onCheckboxChange}
            getProductCount={() => 1}
            isSelectionDisabled={isSelectionDisabled}
            maxProductsLimit={10}
          />
        </Stack>
      </Stack>
    </Box>
    <Divider orientation="vertical" flexItem />
  </>
);

export const FreemiumSelectEditor = ({
  value,
  options,
  onChange,
  title,
}: {
  value: string;
  options: string[];
  onChange: (value: string) => void;
  title: string;
}) => (
  <Box display="flex" flexDirection="column" gap={2} width="50%">
    <Typography variant="h6">{title}</Typography>
    <Select value={value} onChange={e => onChange(e.target.value as string)} size="small">
      {options.map(option => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  </Box>
);
